import { NOTICE, debounceSecond } from 'assets/constant';
import { CardHeader } from 'components/common';
import BoardJodit from 'components/common/board/BoardJodit';
import BreadCrumb from 'components/shared/BreadCrumb';
import { useSupporting } from 'hooks';
import { useNoticeState } from 'hooks/supporting/useNoticeState';
import { usePostSupporting } from 'hooks/supporting/usePostSupporting';
import usePutSupporting from 'hooks/supporting/usePutSupporting';
import { debounce } from 'lodash';
import { BoardFixed, BoardTitle, BoardType } from 'pages/supporting';
import { BoardEditFile } from 'pages/supporting/BoardEditFile';
import { BoardPopupPublic } from 'pages/supporting/BoardPopupPublic';
import { useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router';

export const NoticeEdit = () => {
  const { noticeId } = useParams();
  const navigate = useNavigate();
  const {
    noticeState,
    handleTitleChange,
    handleContentChange,
    handlePostStateChange,
    handlePostTypeChange,
    handleTopFixFlagChange,
    handleFileChange,
    resetNoticeState,
    handleEditFileChange,
  } = useNoticeState();
  // const { writeMutation } = usePostSupporting();
  const { editMutation } = usePutSupporting(noticeId);
  const { editFileMutate } = usePostSupporting(noticeId);

  const {
    // 지원센터 공지&뉴스 디테일 api
    supportNoticeNewsDetailData,
    supportNoticeNewsDetailIsLoading,
    supportNoticeNewsDetailIsError,
  } = useSupporting(noticeId, NOTICE);

  const debounceHandleSubmit = debounce(async () => {
    const { fileList, thumbnail, editFileList, ...boardPostData } = noticeState;
    try {
      const formData = new FormData();
      if (fileList.length > 0)
        fileList.forEach((file) => {
          formData.append('mediaList', file);
        });
      if (fileList.length > 0) editFileMutate.mutate(formData);
      editMutation.mutate(boardPostData);
      navigate(`/notice/detail/${noticeId}`);
    } catch (error) {
      console.error('error', error);
    }
  }, debounceSecond);

  const handleSubmit = (e) => {
    e.preventDefault();
    debounceHandleSubmit();
  };

  useEffect(() => {
    if (!supportNoticeNewsDetailData) return;
    const { title, content, postState, postType, topFixFlag, mediaInfoDtoList } = supportNoticeNewsDetailData;
    handleTitleChange(title);
    handleContentChange(content);
    handlePostStateChange(postState);
    handlePostTypeChange(postType);
    handleTopFixFlagChange(topFixFlag);
    handleEditFileChange(mediaInfoDtoList);
    return () => {
      resetNoticeState();
    };
  }, [supportNoticeNewsDetailData]);

  return (
    <>
      <main id='main' className='main'>
        <BreadCrumb home={'/'} sublink={'/notice'} title={'Help Center'} subTitle={'지원센터'}>
          &nbsp;/ 자료실 / 공지 등록/수정
        </BreadCrumb>
        <div className='card p-20'>
          <CardHeader noRightBorder={false} title='공지사항' visibleContent={false}></CardHeader>

          <Form onSubmit={handleSubmit} action='' className='write-form'>
            <BoardType value={noticeState.postType} onChange={handlePostTypeChange} />
            <BoardTitle value={noticeState.title} onChange={handleTitleChange} />
            <BoardPopupPublic value={noticeState.postState} onChange={handlePostStateChange} />
            {/* <BoardPublic value={noticeState.postState} onChange={handlePostStateChange} /> */}
            <BoardFixed value={noticeState.topFixFlag} onChange={handleTopFixFlagChange} />
            {/* <BoardThumbnail value={noticeState.thumbnail} onChange={handleThumbnailChange} /> */}
            {/* <BoardQuill value={noticeState.content} onChange={handleContentChange} /> */}
            <BoardJodit value={noticeState.content} onChange={handleContentChange} />
            {/* <BoardCKEditor value={noticeState.content} onChange={handleContentChange} /> */}

            <BoardEditFile value={noticeState.fileList} onChange={handleFileChange} />

            {/* 첨부파일 */}

            <div className='d-flex align-items-center justify-content-center border-top pt-3'>
              <Button type='submit' variant='primary' className='me-2'>
                등록
              </Button>
              <Button onClick={() => navigate(`/notice/detail/${noticeId}`)} variant='secondary'>
                취소
              </Button>
            </div>
          </Form>
        </div>
      </main>
    </>
  );
};
